import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useProfilePicture } from "../../../features/UserProfile/useProfilePicture";
import { useSelector } from "react-redux";
import { capitaliseStr } from "../../../utils";
import { RootState } from "../../../store";
import Image from "../Image";
import DropdownProfile from "./DropdownProfile";
import styles from "./UserProfile.module.css";

const getInitials = (name: string) =>
  name
    ?.split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase() || "";

export default function UserProfile() {
  const { user } = useSelector((state: RootState) => state.auth);
  const [isOpen, setIsOpen] = useState(false);

  const localUser = useAuth().user;
  const userFullName = user?.userFullName || "";
  const isProfileImageAvailable = localUser?.isProfileImageAvailable || false;
  const { isLoading, profilePicture } = useProfilePicture(
    isProfileImageAvailable,
  );

  const toggleDropdown = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  return (
    <div className={styles["nav__profile__container"]} onClick={toggleDropdown}>
      <div className={styles["nav__profile__picture"]}>
        {!isProfileImageAvailable && getInitials(userFullName)}
        {!!isProfileImageAvailable && !isLoading && (
          <Image
            src={profilePicture}
            alt="profile"
            className={styles["header__profile__pic"]}
          />
        )}
      </div>

      <div className={styles["nav__profile__info"]}>
        <p className={styles["nav__profile__userName"]}>
          {capitaliseStr(userFullName)}
        </p>
        <p className={styles["nav__profile__designation"]}>
          {capitaliseStr(user?.roleName || "")}
        </p>
      </div>

      {isOpen && (
        <DropdownProfile handleCloseDropdown={() => setIsOpen(false)} />
      )}
    </div>
  );
}
